// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31gdd","image":"Header_image__3wwZB","name":"Header_name__3oc4X","info":"Header_info__1lXFP","infoRow":"Header_infoRow__1mh7P"};